import coins from "./coins/coins.json";

type CoinInfo = {
  full_name: string;
  icon: string;
  name: string;
};

export function coin_list() {}

export function get_coin_info(coin: string): CoinInfo {
  // @ts-ignore
  const info = coins.find((item) => {
    return item.address === coin;
  });

  if (info) {
    return {
      full_name: info.name,
      icon: info.logoURI,
      name: info.symbol,
    };
  }
  return {
    full_name: "",
    icon: "",
    name: "",
  };
}

export function short_name(name: string) {
  return get_coin_info(name).name;
}

export function full_name(name: string) {
  return get_coin_info(name).full_name;
}
